import React, { useState } from "react";
import { Link } from "react-router-dom";
import { DISCLAIMER } from "../constants/disclaimer";

const KEY = "flavoria_consent_v1";

export function ConsentGate() {
  const [agreed, setAgreed] = useState(() => {
    try { return localStorage.getItem(KEY) === "yes"; } catch { return true; }
  });
  const [checked, setChecked] = useState(false);
  if (agreed) return null;

  const agree = () => {
    try { localStorage.setItem(KEY, "yes"); } catch {}
    setAgreed(true);
  };

  return (
    <div data-testid="consent-gate" role="dialog" aria-modal="true" aria-label="Disclaimer consent"
      className="fixed inset-0 z-[200] flex items-center justify-center bg-ink/60 backdrop-blur-sm p-4">
      <div className="w-full max-w-lg rounded-3xl bg-white border border-border shadow-lift p-6 sm:p-8 flex flex-col max-h-[88vh]">
        <h2 className="font-heading text-2xl font-black text-ink">Before you continue</h2>
        <p className="mt-2 text-sm text-ink-soft">
          Flavoria curates recipes from third-party creators and public sources for general information only.
          Please read our Disclaimer, then agree to continue.
        </p>
        <div data-testid="consent-disclaimer-scroll"
          className="mt-4 flex-1 min-h-0 overflow-y-auto rounded-2xl border border-border bg-cream/40 p-4 text-sm text-ink-soft space-y-4">
          {DISCLAIMER.map((s) => (
            <div key={s.n}>
              <p className="font-bold text-ink">{s.n}. {s.h}</p>
              {s.paras.map((p, i) => <p key={i} className="mt-1 leading-relaxed">{p}</p>)}
            </div>
          ))}
        </div>
        <label className="mt-4 flex items-start gap-3 text-sm font-semibold text-ink cursor-pointer">
          <input type="checkbox" data-testid="consent-checkbox" checked={checked}
            onChange={(e) => setChecked(e.target.checked)} className="mt-0.5 w-5 h-5 accent-coral shrink-0" />
          <span>I have read and agree to the{" "}
            <Link to="/disclaimer" target="_blank" rel="noopener noreferrer" className="text-coral underline">Disclaimer</Link>.
          </span>
        </label>
        <button onClick={agree} disabled={!checked} data-testid="consent-agree-button"
          className="mt-5 h-12 rounded-full bg-coral hover:bg-coral-hover text-white font-black transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Agree and Continue
        </button>
      </div>
    </div>
  );
}
